<template>
  <Checklist :id="this.$route.params.id"/>
</template>

<script>
import Checklist from '@/components/checklist_detail.vue'

export default {
  name: 'ChecklistDetail',
  components: {
    Checklist
  }
}
</script>
